export default {
  actionTypes: {
    loadEmployees: 'LOAD_EMPLOYEES',
    updatePaginationInfo: 'UPDATE_PAGINATION_INFO',
    onFilterQueryChanged: 'ON_FILTER_QUERY_CHANGED',
    addNewEmployee: 'ADD_NEW_EMPLOYEE',
    updateEmployee: 'UPDATE_EMPLOYEE',
    loadRoles: 'LOAD_ROLES',
    loadManagers: 'LOAD_MANAGERS',
    loadClients: 'LOAD_CLIENTS',
    resendEmailVerification: 'RESEND_EMAIL_CONFIRMATION',
  },
  mutationTypes: {
    setEmployees: 'SET_EMPLOYEES',
    setEmployeesTotal: 'SET_EMPLOYEES_TOTAL',
    setIsLoading: 'SET_IS_LOADING',
    setPaginationInfo: 'SET_PAGINATION_INFO',
    setFilterQuery: 'SET_FILTER_QUERY',
    setRoles: 'SET_ROLES',
    setManagers: 'SET_MANAGERS',
    setClients: 'SET_CLIENTS',
    setPaginationInfoPageNumber: 'SET_PAGINATION_PAGE_NUMBER',
  },
};
